/* eslint-disable no-confusing-arrow,prettier/prettier */
import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';
import get from 'lodash/get';

import { actions as currentCommunityInfo } from '../../redux/communities/currentCommunityInfo';
import { actions as communityPreview } from '../../redux/communities/communityPreview';
import { actions as postsPreviewActions } from '../../redux/communities/communityPostsPreview';
import { actions as imageUpdateActions } from '../../redux/communities/communityImageUpdate';
import { actions as imageRemoveActions } from '../../redux/communities/communityImageRemove';
import { actions as postActions } from '../../redux/communities/communityPosts';
import { actions as currentCommunityScrollStatus } from '../../redux/communities/currentCommunityScrollStatus';
import { actions as postsList } from '../../redux/communities/postsList';
import {
  currentCommunityInfoSelector,
  sendingCurrentCommunityInfoSelector,
  currentCommunityTemporaryPostsSelector,
} from '../../redux/communities/selectors/currentCommunity';
import {
  communityPreviewSelector,
  sendingCommunityPreviewSelector,
} from '../../redux/communities/selectors/communityPreview';
import { selectCommunityImageProcessing } from '../../redux/communities/selectors/selectors';
import { COMMUNITIES_USER_ROLES } from '../../constants';
import { uiSidebarSelector } from '../../redux/ui/selectors';
import { withLoggedIn } from '../../hocs/withLoggedIn';
import styles from './index.styl';


const mapStateToProps = (state, { isLoggedIn }) => {
  return {
    postsList: state.communities.postsList,
    isDrawerVisible: uiSidebarSelector(state),
    temporaryPostList: currentCommunityTemporaryPostsSelector(state),
    imageProcessing: selectCommunityImageProcessing(state),
    community: isLoggedIn
      ? currentCommunityInfoSelector(state)
      : communityPreviewSelector(state),
    communityLoading: isLoggedIn
      ? sendingCurrentCommunityInfoSelector(state)
      : sendingCommunityPreviewSelector(state),
  };
};

const privateActions = (d, communityId) => ({
  fetchCommunity: () => d(currentCommunityInfo.send({ id: communityId })),
  fetchPosts: () => d(postActions.getPosts({ communityId })),
  fetchMorePosts: () => d(postActions.getOlderPosts({ communityId })),
  resetCommunity: () => d(currentCommunityInfo.resetCommunity()),
  setScrollStatus: payload => d(currentCommunityScrollStatus.setScroll(payload)),
  addPostsList: payload => d(postsList.addNewPost(payload)),
  resetScrollStatus: () => d(currentCommunityScrollStatus.reset()),
  updateImage: data => d(imageUpdateActions.send({ communityId, ...data })),
  removeImage: data => d(imageRemoveActions.send({ communityId, ...data })),
});
const publicActions = (d, communityId) => ({
  fetchCommunity: () => d(communityPreview.send({ id: communityId })),
  fetchPosts: () => d(postsPreviewActions.getPostsPreview({ communityId })),
  fetchMorePosts: () => d(postsPreviewActions.getOlderPostsPreview({ communityId })),
  resetCommunity: () => d(communityPreview.resetCommunity()),
  updateImage: () => {},
  removeImage: () => {},
});

const mapDispatchToProps = (dispatch, { routeParams, isLoggedIn }) => {
  const communityId = +get(routeParams, 'communityId');

  return isLoggedIn
    ? privateActions(dispatch, communityId)
    : publicActions(dispatch, communityId);
};

export const enhance = compose(
  injectIntl,
  withLoggedIn,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(({
    routeParams,
    postsList,
    community: {
      totalPosts,
      currentUserRole,
    },
  }) => ({
    communityId: +get(routeParams, 'communityId'),
    shouldLoadMore: Boolean(postsList.length && totalPosts > postsList.length),
    isModerator: currentUserRole === COMMUNITIES_USER_ROLES.MODERATOR,
  })),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/Community/enhance.jsx